import { jsx, jsxs } from 'react/jsx-runtime';
import { cx } from 'class-variance-authority';
import { useState } from 'react';
import { NavigationContext } from '../NavigationContext/NavigationContext.js';

const ControlledNavigationBar = ({ className, expandCollapse, isExpanded, listItems, productMenu, setIsExpanded, userMenu, }) => {
    return (jsx(NavigationContext.Provider, { value: { isExpanded, setIsExpanded }, children: jsx("div", { className: cx("mci-group/nav-bar mci-sticky mci-top-0", isExpanded ? "mci-w-full" : "mci-w-fit"), children: jsxs("nav", { "aria-label": "main", className: cx("mci-relative mci-flex mci-h-dvh mci-flex-col mci-gap-xxs mci-overflow-hidden mci-border-r-1 mci-border-gray-300 mci-bg-white", className), children: [productMenu, listItems, userMenu, expandCollapse] }) }) }));
};
const NavigationBar = ({ defaultIsExpanded, ...rest }) => {
    const [isExpanded, setIsExpanded] = useState(defaultIsExpanded ?? true);
    return (jsx(ControlledNavigationBar, { isExpanded: isExpanded, setIsExpanded: setIsExpanded, ...rest }));
};

export { ControlledNavigationBar, NavigationBar };
